import { render, staticRenderFns } from "./AppAlert.vue?vue&type=template&id=fca0c5d4&scoped=true&lang=pug"
import script from "./AppAlert.vue?vue&type=script&lang=ts"
export * from "./AppAlert.vue?vue&type=script&lang=ts"
import style0 from "./AppAlert.vue?vue&type=style&index=0&id=fca0c5d4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca0c5d4",
  null
  
)

export default component.exports